import { Scenarios } from '@jfs/network'
const validateBeneficiaryCharges = {
  default: [
    {
      url: /getCommonCodeByKey\/VALIDATE_BENE/,
      method: 'GET',
      response: {
        status: 'SUCCESS',
        code: 200,
        data: [
          {
            id: '2',
            code: 'VALIDATE_BENEFICIARY',
            key: 'VALIDATE_BENE',
            value:
              '{"entity":{"initiatingEntityId":2103,"application":2103,"type":12,"entityId":"100002000003382"},"amount":{"grossAmount":2.54},"queryParameters":{"bankId":"","card":{"cardBin":"*","scheme":"","type":""},"method":{"type":"309","subType":"550"}}}',
            category: 'VALIDATE_BENEFICIARY_ACCOUNT',
            description: 'VALIDATE_BENEFICIARY_AMOUNT',
            createdBy: '3113',
            updatedBy: '3113',
          },
        ],
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /getCommonCodeByKey\/VALIDATE_BENE/,
      method: 'GET',
      responseCode: 501,
      response: { status: 'FAILURE', error: { code: '33607', message: 'INVALID.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { validateBeneficiaryCharges }
